import { Route } from '@angular/router';
import { IsLoggedInGuard, RequiresPermissionGuard } from '@lexplus-authentication';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../localized-user-routes-const';
import { UserDetailDrawerRoute } from '../../global/functions/user-detail-drawer-route.function';
import { AUFGABEN_PERMISSIONS } from './functions/build-aufgabe-detail-drawer-type.function';

/**
 * The routes of the Aufgaben page including their guards.
 *
 * The detail drawer is a **nested** child of the overview, which keeps the overview mounted
 * behind it. Its URL is the one notification mails deep-link to, `/<locale>/aufgaben/details/:id`.
 *
 * @param {string} localeId - The language ID that determines the localized routes
 * @returns {Route} The Aufgaben page's route with its child routes
 */
export function AufgabenPageRoute(localeId: string): Route {
  const locale = localeId?.split('-')[0] || 'en';

  return {
    path: '',
    canActivate: [IsLoggedInGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_TASKS][locale],
      },
      {
        path: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_TASKS][locale],
        loadComponent: () => import('./pages/aufgaben-page/aufgaben-page.component').then((m) => m.AufgabenPageComponent),
        canActivate: [IsLoggedInGuard, RequiresPermissionGuard],
        data: { routeId: USER_ROUTES_IDS.USER_TASKS, requiredAnyPermission: AUFGABEN_PERMISSIONS },
        children: [
          UserDetailDrawerRoute('aufgabe', LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.DETAILS][locale], USER_ROUTES_IDS.USER_TASKS, locale),
        ],
      },
    ],
  };
}
